import React from "react";
import PropTypes from "prop-types";

const Spinner = ({ text, loading }) =>
  loading === true ? (
    <React.Fragment>
      <span
        className="spinner spinner-border spinner-border-sm position-absolute"
        style={{ left: "10%", top: 10 }}
      />
      {text}
    </React.Fragment>
  ) : (
    ""
  );

Spinner.propTypes = {
  text: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner.jsx